import React from 'react';
import {
  AppDataServiceProvider, AppSettingsProvider,
  AppShellProvider, AppStoreProvider, AppThemeProvider
} from './core/provider'
import { App } from './app/App';
import './index.css';
import { createRoot } from 'react-dom/client';
import { isEmbeddedInDynamics } from './core/utils/utils';

// Publish the embed state on the shared window as a single source of truth. The
// Deal Assistance extension (a Direflow web component sharing this window, always a
// prod build) reads `window.__DA_EMBEDDED_IN_DYNAMICS__` to make embed-aware chrome
// decisions (e.g. hiding its breadcrumb Home button) — including the portal's local
// `?source=iframe` dev override, which the extension's own prod build can't compute.
try {
  (window as unknown as { __DA_EMBEDDED_IN_DYNAMICS__?: boolean }).__DA_EMBEDDED_IN_DYNAMICS__ =
    isEmbeddedInDynamics();
} catch {
  /* non-fatal: extension falls back to its own detection */
}

// Suppress the benign "ResizeObserver loop completed with undelivered notifications"
// error. It is a harmless browser notification (commonly emitted by ag-grid / Fluent UI
// during layout) that Create React App's dev overlay incorrectly surfaces as an uncaught
// runtime error. Swallowing it prevents the overlay from blocking the UI.
const isResizeObserverLoopError = (message?: string): boolean =>
  typeof message === 'string' &&
  (message.includes('ResizeObserver loop completed with undelivered notifications') ||
    message.includes('ResizeObserver loop limit exceeded'));

globalThis.addEventListener(
  'error',
  (event) => {
    if (isResizeObserverLoopError(event.message)) {
      event.stopImmediatePropagation();
      event.preventDefault();
    }
  },
  true
);

globalThis.addEventListener('unhandledrejection', (event) => {
  if (isResizeObserverLoopError(event.reason?.message ?? String(event.reason))) {
    event.stopImmediatePropagation();
    event.preventDefault();
  }
});

//const root = ReactDOM.createRoot(document.getElementById("app"));

const container = document.getElementById('app');
const root = createRoot(container);

root.render(
  <AppShellProvider>
    <AppStoreProvider>
      <AppDataServiceProvider>
        <AppSettingsProvider>
          <AppThemeProvider>
            <App />
          </AppThemeProvider>
        </AppSettingsProvider>
      </AppDataServiceProvider>
    </AppStoreProvider>
  </AppShellProvider>
);

// ReactDOM.render(
//   <AppShellProvider>
//     <AppStoreProvider>
//       <AppDataServiceProvider>
//         <AppSettingsProvider>
//           <AppThemeProvider>
//             <App />
//           </AppThemeProvider>
//         </AppSettingsProvider>
//       </AppDataServiceProvider>
//     </AppStoreProvider>
//   </AppShellProvider>,
//   document.getElementById("app")
// );
